import cx from 'classnames'
import type { PropsWithChildren, ReactNode } from 'react'

import { Stack } from '../stack/Stack'
import { Typography } from '../typography/Typography'

type Props = PropsWithChildren<{
  title?: ReactNode
  className?: string
}>

export const CardItems = ({ children, title, className }: Props) => (
  <Stack className={cx('flex-col', className)} gap="condensed">
    {title && (
      <Typography as="h3" weight="semibold">
        {title}
      </Typography>
    )}
    {children}
  </Stack>
)
